export const tokens = {
  surface: {
    base: '#1C1D22',
    raised: '#212329',
    glass: 'rgba(34, 32, 32, 0.5)',
    inset: 'rgba(255, 255, 255, 0.04)',
  },
  border: {
    hairline: 'rgba(255, 255, 255, 0.08)',
    strong: 'rgba(255, 255, 255, 0.12)',
  },
  accent: {
    base: '#ff9900',
    gradient: 'linear-gradient(135deg, #ff9900, #ff7d00)',
    soft: 'rgba(255, 153, 0, 0.14)',
    onDark: '#ffb14d',
    ink: '#1b1205',
    glow: '0 12px 36px -16px rgba(255, 153, 0, 0.4)',
    glowTint: 'rgba(255, 153, 0, 0.2)',
    glowBorder: 'rgba(255, 153, 0, 0.24)',
    navGlow: 'inset 0 0 0 1px rgba(255, 153, 0, 0.3), 0 6px 18px -8px rgba(255, 153, 0, 0.45)',
  },
  status: {
    success: { fg: '#34D17B', bg: 'rgba(36, 208, 123, 0.15)' },
    warning: { fg: '#F4D03F', bg: 'rgba(244, 208, 63, 0.15)' },
    danger: { fg: '#FF5B5B', bg: 'rgba(255, 91, 91, 0.15)' },
    info: { fg: '#3AA0FF', bg: 'rgba(58, 160, 255, 0.15)' },
    neutral: { fg: '#B2B8C2', bg: 'rgba(255, 255, 255, 0.06)' },
    accent: { fg: '#FFB14D', bg: 'rgba(255, 153, 0, 0.16)' },
  },
  text: {
    primary: '#F4F5F7',
    secondary: '#B2B8C2',
    muted: '#969EAB',
  },
  radius: {
    control: '10px',
    card: '15px',
    chip: '8px',
    nav: '11px',
  },
  shadow: {
    card: '0 8px 24px -16px rgba(0, 0, 0, 0.6)',
  },
  blur: '13px',
  space: {
    xs: '0.5rem',
    sm: '0.75rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  font: {
    display: '26px',
    h1: '19px',
    h2: '16px',
    body: '13px',
    label: '11.5px',
    micro: '10.5px',
  },
  motion: {
    duration: '0.2s',
    ease: 'ease',
  },
} as const
